import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageSquarePlus } from 'lucide-react';

import { CONVERSATION_TYPE, CONVERSATION_USER_ROLE } from './enums';

import { Button } from '@/components/ui/button';

import { usePostConversation } from '@/data/conversation';
import { useSelf } from '@/data/user';

const ContactCoachButton = ({ coach }) => {
  const postConversation = usePostConversation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const self = useSelf();
  const navigate = useNavigate();

  const handleClick = async () => {
    try {
      setIsSubmitting(true);
      const conversation = await postConversation({
        type: CONVERSATION_TYPE.DIRECT_MESSAGE,
        users: [
          {
            userId: self.data.id,
            role: CONVERSATION_USER_ROLE.CLIENT
          },
          {
            userId: coach.user.id,
            role: CONVERSATION_USER_ROLE.COACH
          }
        ]
      });
      setIsSubmitting(false);
      navigate(`/conversation/${conversation.id}`);
    } catch (error) {
      setIsSubmitting(false);
    }
  };

  if (!self.data) {
    return null;
  }

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleClick}
      disabled={isSubmitting}
    >
      <MessageSquarePlus className="mr-2 h-5 w-5" />
      Message
    </Button>
  );
};

export default ContactCoachButton;
